(function ($, Drupal) {
  'use strict';
  Drupal.behaviors.recipesFilters = {
    attach: function (context, settings) {
      $(once('recipe-filters', '.view-recipes-filter', context)).each(function (index) {
        var $mobileToggle = $('.mobile-filters-toggle');
        $mobileToggle.on('click', function () {
          if ($(this).hasClass('open')) {
            $mobileToggle.removeClass('open').addClass('close');
            $('.filters-wrapper').removeClass('open');
          }
          else {
            $mobileToggle.removeClass('close').addClass('open');
            $('.filters-wrapper').addClass('open');
          }
        });

        var waitForFinalEvent = (function () {
          var timers = {};
          return function (callback, ms, uniqueId) {
            if (!uniqueId) {
              uniqueId = 'Don\'t call this twice without a uniqueId';
            }
            if (timers[uniqueId]) {
              clearTimeout(timers[uniqueId]);
            }
            timers[uniqueId] = setTimeout(callback, ms);
          };
        })();

        $(window).resize(function () {
          waitForFinalEvent(function () {
            var window = $(this);
            if (window.width() > 768) {
              $('.filters-wrapper').addClass('open');
            }
          }, 0, 'resizing');
        });
      });
    }
  };
}
)(jQuery, Drupal);
